import { getPermissions, hasPermission } from "../../utilis/permissionStorage";
import React from "react";
import { useState, useEffect } from "react";
import Button from "../base/Button";
import { apiUrl } from "../ApiManager/AxiosHeaders";
import ReactPaginate from "react-paginate";

function LeadsReporting() {
  const [permissions, setPermissions] = useState([]);
  const [pagination, setPagination] = useState({
    currentPage: 1,
    perPage: 10,
    total: 0,
    lastPage: 1,
  });
  const [filterKey, setFilterKey] = useState(0);
  const [leadsData, setLeadsData] = useState([]);
  const [loading, setLoading] = useState(false);

  const [leadStartDate, setLeadStartDate] = useState("");
  const [leadEndDate, setLeadEndDate] = useState("");
  const [leadStatus, setLeadStatus] = useState("");
  const [clientName, setClientName] = useState("");
  const [leadSummary, setLeadSummary] = useState({});

  const [selectedLead, setSelectedLead] = useState(null);
  const [showModal, setShowModal] = useState(false);

  useEffect(() => {
    setPermissions(getPermissions());
  }, []);

  const leadStatusOptions = [
    { value: "", label: "All" },
    { value: "very_good", label: "Very Good" },
    { value: "good", label: "Good" },
    { value: "average", label: "Average" },
    { value: "poor", label: "Poor" },
  ];

  const handlePerPageChange = (e) => {
    setPagination((prev) => ({
      ...prev,
      perPage: parseInt(e.target.value),
      currentPage: 1,
    }));
  };

  const handlePageChange = (selectedItem) => {
    setPagination((prev) => ({
      ...prev,
      currentPage: selectedItem.selected + 1,
    }));
  };

  const fetchLeadsData = async () => {
    setLoading(true);
    try {
      const response = await apiUrl.get("/lead-scores", {
        params: {
          page: pagination.currentPage,
          per_page: pagination.perPage,
          status: leadStatus,
          start_date: leadStartDate,
          end_date: leadEndDate,
          client_name: clientName,
        },
      });
      if (response?.status) {
        setLeadSummary(response?.data?.lead_summary || {});
        setLeadsData(response?.data?.data);
        setPagination((prev) => ({
          ...prev,
          total: response?.data?.pagination?.total,
          lastPage: response?.data?.pagination?.lastPage,
        }));
      }
    } catch (error) {
      console.error("Error fetching leads data:", error);
    } finally {
      setLoading(false);
    }
  };
  useEffect(() => {
    fetchLeadsData();
  }, [filterKey, pagination.currentPage, pagination.perPage]);

  const scoringRules = selectedLead
    ? [
        {
          name: "Call Response",
          maxPoints: 15,
          earned: selectedLead.score.call_response_points,
          rules: [
            "Answered & < 3 contacts → 15 points",
            "Answered & ≥ 3 contacts (no docs) → 8 points",
            "No answer after 3 attempts → 0 points",
          ],
          rule:
            selectedLead.score.call_response_points === 15
              ? "Answered and contacted less than 3 times"
              : selectedLead.score.call_response_points === 8
              ? "Answered but no documents after 3+ contacts"
              : "No response after 3 contact attempts",
        },
        {
          name: "Documents Received",
          maxPoints: 15,
          earned: selectedLead.score.documents_points,
          rules: [
            "Documents received → 15 points",
            "Documents not received → 0 points",
          ],
          rule:
            selectedLead.score.documents_points === 15
              ? "Documents received"
              : "Documents not received",
        },
        {
          name: "Age",
          maxPoints: 10,
          earned: selectedLead.score.age_points,
          rules: ["Age 18-30 → 10 points", "Other ages → 0 points"],
          rule:
            selectedLead.score.age_points === 10
              ? `Age ${selectedLead.age} (18-30 range)`
              : `Age ${selectedLead.age} (outside optimal range)`,
        },
        {
          name: "Education Level",
          maxPoints: 10,
          earned: selectedLead.score.education_points,
          rules: [
            "Intermediate or Bachelor → 10 points",
            "Master → 8 points",
            "Other → 0 points",
          ],
          rule:
            selectedLead.score.education_points === 10
              ? "Intermediate or Bachelor degree"
              : selectedLead.score.education_points === 8
              ? "Master degree"
              : "Other education level",
        },
        {
          name: "Academic Score",
          maxPoints: 20,
          earned: selectedLead.score.academic_points,
          rules: [
            "80%+ → 20 points (Very Good)",
            "60-79% → 15 points (Good)",
            "50-59% → 10 points (Average)",
            "<50% → 0 points (Poor)",
          ],
          rule:
            selectedLead.score.academic_points === 20
              ? "Academic score 80%+ (Very Good)"
              : selectedLead.score.academic_points === 15
              ? "Academic score 60-79% (Good)"
              : selectedLead.score.academic_points === 10
              ? "Academic score 50-59% (Average)"
              : "Academic score <50% (Poor)",
        },
        {
          name: "Study Gap",
          maxPoints: 15,
          earned: selectedLead.score.study_gap_points,
          rules: [
            "Intermediate: ≤1yr → 15point, ≤2yr → 12points, ≤3yr → 8points, >3yr → 0points",
            "Bachelor (any gap) → 12 points",
          ],
          rule:
            selectedLead.score.study_gap_points === 15
              ? "Intermediate completed within 1 year"
              : selectedLead.score.study_gap_points === 12
              ? "Gap within 2 years or Bachelor with gap"
              : selectedLead.score.study_gap_points === 8
              ? "Gap within 3 years"
              : "Large study gap",
        },
        {
          name: "English Test Score",
          maxPoints: 15,
          earned: selectedLead.score.english_test_points,
          rules: [
            "6.5+ → 15 points (Very Good)",
            "6.0 → 12 points (Good)",
            "5.5 → 8 points (Average)",
            "5.0 → 0 points (Poor)",
            "No test → 8 points (Average)",
          ],
          rule:
            selectedLead.score.english_test_points === 15
              ? "Test score 6.5+ (Very Good)"
              : selectedLead.score.english_test_points === 12
              ? "Test score 6.0 (Good)"
              : selectedLead.score.english_test_points === 8
              ? "Test score 5.5 or no test (Average)"
              : "Test score 5.0 (Poor)",
        },
      ]
    : [];
  console.log("leadsData", leadsData);
  return (
    <>
      {permissions?.reports && (
        <div className="card px-4 py-4 bg-white shadow rounded-lg">
          {/* Header */}
          <header className="mb-4">
            <h1 className="text-xl font-semibold text-gray-700">
              Leads Reporting
            </h1>
          </header>

          {/* Summary Cards */}
          {leadSummary && (
            <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-5 gap-4 mb-6">
              {/* Very Good */}
              <div className="p-4 rounded-xl bg-green-100 border-l-4 border-green-500">
                <p className="text-sm text-gray-600 font-medium">Very Good</p>
                <h2 className="text-2xl font-bold text-green-700 mt-1">
                  {leadSummary?.very_good}
                </h2>
              </div>

              {/* Good */}
              <div className="p-4 rounded-xl bg-blue-100 border-l-4 border-blue-500">
                <p className="text-sm text-gray-600 font-medium">Good</p>
                <h2 className="text-2xl font-bold text-blue-700 mt-1">
                  {leadSummary?.good}
                </h2>
              </div>

              {/* Average */}
              <div className="p-4 rounded-xl bg-yellow-100 border-l-4 border-yellow-500">
                <p className="text-sm text-gray-600 font-medium">Average</p>
                <h2 className="text-2xl font-bold text-yellow-700 mt-1">
                  {leadSummary?.average}
                </h2>
              </div>

              {/* Poor */}
              <div className="p-4 rounded-xl bg-red-100 border-l-4 border-red-500">
                <p className="text-sm text-gray-600 font-medium">Poor</p>
                <h2 className="text-2xl font-bold text-red-700 mt-1">
                  {leadSummary?.poor}
                </h2>
              </div>

              {/* Total Leads */}
              <div className="p-4 rounded-xl bg-gray-100 border-l-4 border-gray-500">
                <p className="text-sm text-gray-600 font-medium">Total Leads</p>
                <h2 className="text-2xl font-bold text-gray-700 mt-1">
                  {leadSummary?.total_leads}
                </h2>
              </div>
            </div>
          )}

          {/* Filters */}
          <div className="mb-6 bg-gray-50 rounded-lg border border-gray-200 p-4">
            <div className="flex flex-wrap gap-4 mb-3">
              {/* Lead Status */}
              <div className="flex-1 min-w-[180px]">
                <label className="block text-sm font-medium text-gray-600 mb-1">
                  Lead Status
                </label>
                <select
                  className="w-full border border-gray-300 rounded-md p-2 shadow-sm focus:ring-2 focus:ring-blue-500"
                  value={leadStatus}
                  onChange={(e) => setLeadStatus(e.target.value)}
                >
                  {leadStatusOptions.map((item) => (
                    <option key={item.value} value={item.value}>
                      {item.label}
                    </option>
                  ))}
                </select>
              </div>
              {/* client name */}
              <div className="flex-1 min-w-[180px]">
                <label className="block text-sm font-medium text-gray-600 mb-1">
                  Client Name
                </label>
                <input
                  className="w-full border border-gray-300 rounded-md p-2 shadow-sm focus:ring-2 focus:ring-blue-500"
                  type="text"
                  placeholder="Name or lead/user ID"
                  value={clientName}
                  onChange={(e) => setClientName(e.target.value)}
                />
              </div>

              {/* Start Date */}
              <div className="flex-1 min-w-[180px]">
                <label className="block text-sm font-medium text-gray-600 mb-1">
                  Start Date
                </label>
                <input
                  type="date"
                  value={leadStartDate}
                  onChange={(e) => setLeadStartDate(e.target.value)}
                  className="w-full border border-gray-300 rounded-md p-2 shadow-sm focus:ring-2 focus:ring-blue-500"
                />
              </div>

              {/* End Date */}
              <div className="flex-1 min-w-[180px]">
                <label className="block text-sm font-medium text-gray-600 mb-1">
                  End Date
                </label>
                <input
                  type="date"
                  value={leadEndDate}
                  onChange={(e) => setLeadEndDate(e.target.value)}
                  className="w-full border border-gray-300 rounded-md p-2 shadow-sm focus:ring-2 focus:ring-blue-500"
                />
              </div>
            </div>

            {/* Action Buttons */}
            <div className="flex justify-end gap-3">
              <Button
                text="Clear All"
                variant="outline"
                size="sm"
                className="bg-gray-100 border border-gray-300 text-gray-700 px-4 py-2 rounded hover:bg-gray-200"
                onClick={() => {
                  setFilterKey((prev) => prev + 1);
                  setLeadStatus("");
                  setLeadStartDate("");
                  setLeadEndDate("");
                  setClientName("");
                  setPagination((prev) => ({ ...prev, currentPage: 1 }));
                }}
              />

              <Button
                text="Apply Filter"
                variant="primary"
                size="sm"
                className="bg-blue-600 text-white px-4 py-2 rounded border-none hover:bg-blue-700"
                onClick={() => {
                  setPagination((prev) => ({ ...prev, currentPage: 1 }));
                  setFilterKey((prev) => prev + 1);
                }}
              />
            </div>
          </div>

          {/* Table */}
          <div className="overflow-x-auto border rounded-lg">
            <table className="table w-full border">
              <thead className="bg-gray-100 border-b">
                <tr className="text-left">
                  <th className="p-3 text-sm font-semibold text-gray-700">
                    Client Name
                  </th>
                  <th className="p-3 text-sm font-semibold text-gray-700">
                    Email
                  </th>

                  <th className="p-3 text-sm font-semibold text-gray-700">
                    Destination
                  </th>

                  <th className="p-3 text-sm font-semibold text-gray-700">
                    Age
                  </th>
                  <th className="p-3 text-sm font-semibold text-gray-700">
                    Previous Education
                  </th>
                  <th className="p-3 text-sm font-semibold text-gray-700">
                    Academic CGPA/Percentage
                  </th>
                  <th className="p-3 text-sm font-semibold text-gray-700">
                    Study Gap
                  </th>
                  <th className="p-3 text-sm font-semibold text-gray-700">
                    Lead Status
                  </th>
                  <th className="p-3 text-sm font-semibold text-gray-700">
                    Lead Score
                  </th>
                  <th className="p-3 text-sm font-semibold text-gray-700">
                    Created At
                  </th>
                  <th className="p-3 text-sm font-semibold text-gray-700 text-right">
                    Actions
                  </th>
                </tr>
              </thead>

              <tbody>
                {loading ? (
                  [...Array(3)].map((_, i) => (
                    <tr key={i}>
                      <td className="p-3">
                        <div className="h-5 w-32 bg-gray-300 rounded animate-pulse"></div>
                      </td>
                      <td className="p-3">
                        <div className="h-5 w-24 bg-gray-300 rounded animate-pulse"></div>
                      </td>

                      <td className="p-3">
                        <div className="h-5 w-24 bg-gray-300 rounded animate-pulse"></div>
                      </td>
                      <td className="p-3">
                        <div className="h-5 w-24 bg-gray-300 rounded animate-pulse"></div>
                      </td>
                      <td className="p-3">
                        <div className="h-5 w-24 bg-gray-300 rounded animate-pulse"></div>
                      </td>
                      <td className="p-3">
                        <div className="h-5 w-24 bg-gray-300 rounded animate-pulse"></div>
                      </td>
                      <td className="p-3">
                        <div className="h-5 w-24 bg-gray-300 rounded animate-pulse"></div>
                      </td>
                      <td className="p-3">
                        <div className="h-5 w-24 bg-gray-300 rounded animate-pulse"></div>
                      </td>
                      <td className="p-3">
                        <div className="h-5 w-20 bg-gray-300 rounded animate-pulse"></div>
                      </td>
                      <td className="p-3">
                        <div className="h-5 w-20 bg-gray-300 rounded animate-pulse"></div>
                      </td>
                      <td className="p-3 text-right">
                        <div className="h-8 w-32 bg-gray-300 rounded animate-pulse ml-auto"></div>
                      </td>
                    </tr>
                  ))
                ) : leadsData?.length === 0 ? (
                  <tr>
                    <td
                      colSpan={12}
                      className="text-center py-6 text-gray-500 text-sm"
                    >
                      No Data Found.
                    </td>
                  </tr>
                ) : (
                  leadsData?.map((item, idx) => {
                    const status = item?.score?.score_category;

                    const colorClass =
                      status === "Very Good"
                        ? "bg-green-100 text-green-700"
                        : status === "Good"
                        ? "bg-blue-100 text-blue-700"
                        : status === "Average"
                        ? "bg-yellow-100 text-yellow-700"
                        : "bg-red-100 text-red-700";

                    return (
                      <tr key={idx} className="border-b hover:bg-gray-50">
                        <td className="p-3">{item?.client_name || "--"}</td>
                        <td className="p-3">{item?.email || "--"}</td>
                        <td className="p-3">
                          {item?.destination_country || "--"}
                        </td>
                        <td className="p-3">{item?.age || "--"}</td>
                        <td className="p-3">{item?.education || "--"}</td>

                        {/* CGPA / Percentage */}
                        <td className="p-3">
                          {item?.academic_cgpa
                            ? item.academic_cgpa
                            : item?.academic_percentage
                            ? `${item.academic_percentage}%`
                            : "--"}
                        </td>

                        <td className="p-3">{item?.study_gap || "--"}</td>

                        {/* Status Badge */}
                        <td className="p-3">
                          <span
                            className={`px-3 py-1 text-xs font-semibold rounded-full ${colorClass}`}
                          >
                            {status?.replace("_", " ")?.toUpperCase() || "--"}
                          </span>
                        </td>

                        {/* Score Badge */}
                        <td className="p-3">
                          <span className="px-3 py-1 bg-indigo-100 text-indigo-700 rounded-full text-xs font-semibold whitespace-nowrap">
                            {item?.score?.total_score ?? "--"} / 100
                          </span>
                        </td>

                        {/* Date */}
                        <td className="p-3">
                          {item?.created_at
                            ? new Date(item.created_at).toLocaleString(
                                "en-GB",
                                {
                                  day: "2-digit",
                                  month: "2-digit",
                                  year: "numeric",
                                  hour: "2-digit",
                                  minute: "2-digit",
                                }
                              )
                            : "--"}
                        </td>

                        {/* Actions */}
                        <td className="p-3 text-right">
                          <button
                            className="px-4 border-none py-2 rounded bg-amber-500 text-white hover:bg-amber-600 shadow-md"
                            onClick={() => {
                              setSelectedLead(item);
                              setShowModal(true);
                            }}
                          >
                            View Breakdown
                          </button>
                        </td>
                      </tr>
                    );
                  })
                )}
              </tbody>
            </table>
          </div>

          {showModal && selectedLead && (
            <>
              <div
                className="modal-backdrop fade show"
                style={{
                  display: "block",
                  backgroundColor: "rgba(0,0,0,0.45)",
                  zIndex: 1040,
                }}
              />
              <div
                className="modal fade show d-block h-full"
                tabIndex={-1}
                style={{ zIndex: 1050 }}
              >
                <div
                  className="modal-dialog modal-xl modal-dialog-centered h-full"
                  style={{ maxWidth: 800 }}
                >
                  <div className="modal-content border-0 rounded-4 shadow">
                    <div
                      className="modal-header"
                      style={{
                        background: "#f7f8fa",
                        borderBottom: "1px solid #eef2f6",
                      }}
                    >
                      <h5 className="modal-title fw-bold">
                        Lead Breakdown -
                        <span className="text-primary">
                          {selectedLead?.client_name}
                        </span>
                      </h5>
                      <button
                        type="button"
                        className="btn-close"
                        onClick={() => setShowModal(false)}
                      />
                    </div>

                    {/* Modal Body */}
                    <div
                      className="modal-body"
                      style={{ maxHeight: "70vh", overflowY: "auto" }}
                    >
                      <div className="card p-6 bg-gradient-to-br from-blue-50 to-blue-100 mb-4">
                        <div className="text-center space-y-2">
                          <p className="text-sm text-gray-600">Total Score</p>
                          <div className="text-5xl font-bold">
                            {selectedLead?.score?.total_score}/100
                          </div>

                          <div className="w-full bg-gray-200 rounded-full h-2 mt-3">
                            <div
                              className="bg-blue-600 h-2 rounded-full"
                              style={{
                                width: `${
                                  (selectedLead?.score?.total_score / 100) * 100
                                }%`,
                              }}
                            ></div>
                          </div>
                        </div>
                      </div>

                      {/* Scoring Sections */}
                      <div className="space-y-4">
                        <h3 className="font-semibold text-gray-700 mb-3">
                          7-Factor Scoring Breakdown
                        </h3>

                        {scoringRules?.map((rule, idx) => (
                          <div
                            key={idx}
                            className="p-4 bg-white border rounded-lg shadow-sm space-y-2"
                          >
                            {/* Header: Name and Points */}
                            <div className="flex justify-between items-center">
                              <h4 className="font-medium text-gray-800">
                                {rule?.name}
                              </h4>
                              <div className="text-right">
                                <div className="text-lg font-bold text-blue-600">
                                  {rule?.earned}/{rule?.maxPoints} pts
                                </div>
                                <div className="text-xs text-gray-500">
                                  {Math.round(
                                    (rule?.earned / rule?.maxPoints) * 100
                                  )}
                                  %
                                </div>
                              </div>
                            </div>

                            {/* Progress Bar */}
                            <div className="w-full bg-gray-200 rounded-full h-2">
                              <div
                                className="bg-blue-600 h-2 rounded-full transition-all"
                                style={{
                                  width: `${
                                    (rule.earned / rule.maxPoints) * 100
                                  }%`,
                                }}
                              />
                            </div>

                            {/* Applied Rule */}
                            <div className="bg-gray-100 rounded p-2">
                              <p className="text-xs text-gray-500 mb-1">
                                Applied Rule:
                              </p>
                              <p className="text-sm font-medium text-gray-800">
                                {rule.rule}
                              </p>
                            </div>

                            {/* All Rules */}
                            <div className="text-xs text-gray-500 space-y-1 pt-2 border-t">
                              <p className="font-medium">All possible rules:</p>
                              <ul className="space-y-1 pl-3 list-disc">
                                {rule.rules.map((r, i) => (
                                  <li key={i}>{r}</li>
                                ))}
                              </ul>
                            </div>
                          </div>
                        ))}
                      </div>
                    </div>

                    {/* Footer */}
                    <div
                      className="modal-footer d-flex justify-content-end align-items-center gap-2"
                      style={{
                        background: "#f7f8fa",
                        borderTop: "1px solid #eef2f6",
                      }}
                    >
                      <button
                        className="btn btn-outline-secondary"
                        onClick={() => setShowModal(false)}
                      >
                        Close
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </>
          )}

          {/* Pagination */}
          <div className="row align-items-center mb-5 mt-2">
            <div className="col-auto">
              <select
                value={pagination?.perPage}
                onChange={handlePerPageChange}
                className="form-select"
                style={{ minWidth: 80 }}
              >
                <option value="10">10</option>
                <option value="25">25</option>
                <option value="50">50</option>
                <option value="100">100</option>
                <option value="200">200</option>
              </select>
            </div>
            <div className="col-auto text-muted">
              Page {pagination.currentPage} – Showing{" "}
              {Math.min(
                pagination.perPage,
                pagination.total -
                  (pagination.currentPage - 1) * pagination.perPage
              )}{" "}
              of {pagination.total} entries
            </div>
            <div className="col">
              <ReactPaginate
                previousLabel={"Previous"}
                nextLabel={"Next"}
                breakLabel={"..."}
                pageCount={pagination.lastPage}
                marginPagesDisplayed={2}
                pageRangeDisplayed={3}
                onPageChange={handlePageChange}
                forcePage={pagination.currentPage - 1}
                containerClassName={"pagination justify-content-end mb-0"}
                pageClassName={"page-item"}
                pageLinkClassName={"page-link"}
                previousClassName={"page-item"}
                previousLinkClassName={"page-link"}
                nextClassName={"page-item"}
                nextLinkClassName={"page-link"}
                activeClassName={"active"}
                disabledClassName={"disabled"}
              />
            </div>
          </div>
        </div>
      )}
    </>
  );
}

export default LeadsReporting;
